import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import auto from "../i18n";

export const LANGS = [
  ["es", "Español", "🇪🇸"], ["en", "English", "🇬🇧"], ["fr", "Français", "🇫🇷"], ["de", "Deutsch", "🇩🇪"],
  ["it", "Italiano", "🇮🇹"], ["pt", "Português", "🇵🇹"], ["ru", "Русский", "🇷🇺"],
  ["tr", "Türkçe", "🇹🇷"], ["zh", "中文", "🇨🇳"], ["ja", "日本語", "🇯🇵"], ["hi", "हिन्दी", "🇮🇳"],
];
const CODES = LANGS.map((l) => l[0]);

const translations = {
  en: {
    nav_features: "Features",
    nav_sources: "Sources",
    nav_how: "How it works",
    nav_pricing: "Pricing",
    nav_signin: "Sign In",
    nav_create: "Create Account",
    nav_studio: "Open Studio",

    hero_title_1: "Turn any long video into",
    hero_title_2: "Viral Shorts",
    hero_sub: "AI auto-clips, captions and a Viral Score for TikTok, Reels & YouTube Shorts.",
    hero_placeholder: "Paste a YouTube URL",
    hero_cta: "Get Clips Now",
    hero_note: "Plans from $9.99/mo · Cancel anytime",
    hero_trust: "Trusted by 2.4M+ creators · 4.9 out of 5",

    sources_title: "One AI Clipper, Every Video Source",
    sources_sub: "Paste a link from YouTube, Vimeo, Kick or Twitch — or upload your own file.",

    how_title: "How It Works",
    how_sub: "From a long video to viral clips in 3 simple steps",
    how_1_title: "Paste a YouTube URL",
    how_1_desc: "Drop any video link. Long-form, podcast, gaming stream — anything works.",
    how_2_title: "AI creates clips",
    how_2_desc: "Our AI finds the most viral moments, adds captions and scores them.",
    how_3_title: "Edit & post everywhere",
    how_3_desc: "Fine-tune in the editor, then export for TikTok, Reels and Shorts.",

    pricing_title: "Simple pricing that scales with you",
    pricing_sub: "Start free. Upgrade when you're ready. Cancel anytime.",
    pricing_monthly: "Monthly",
    pricing_yearly: "Yearly",
    pricing_save: "Save 40%",
    pricing_month: "/mo",
    pricing_free_forever: "forever",

    plan_trial_name: "Free Trial",
    plan_pro_name: "Pro",
    plan_premium_name: "Premium",
    plan_vip_name: "VIP",

    testimonials_title: "Loved by creators worldwide",
    testimonials_sub: "Join thousands turning long videos into viral shorts.",

    cta_title: "Ready to go viral?",
    cta_sub: "Paste a video and get your first clips in minutes.",
    cta_button: "Start clipping free",

    footer_tagline: "Turn long videos into viral clips with AI.",
    footer_product: "Product",
    footer_company: "Company",
    footer_legal: "Legal",
    footer_rights: "All rights reserved.",

    // Studio
    studio_title: "Clip Studio",
    studio_chat_hint: "Paste a YouTube link and I'll find the most viral moments for you.",
    studio_input_placeholder: "Paste a YouTube URL here...",
    studio_generate: "Generate clips",
    studio_invalid: "That doesn't look like a valid YouTube link. Try another one.",
    studio_analyzing: "Analyzing the video...",
    studio_finding: "Finding viral moments...",
    studio_scoring: "Scoring clips...",
    studio_captions: "Writing captions...",
    studio_done: "I found {n} clips with high viral potential 🔥",
    studio_your_clips: "Your clips",
    studio_viral_score: "Viral Score",
    studio_edit: "Edit clip",
    studio_export: "Export",
    studio_back: "Back to clips",
    studio_you: "You",
    studio_new: "New video",

    // Editor
    editor_title: "Clip Editor",
    editor_preview: "Preview",
    editor_caption_style: "Caption style",
    editor_aspect: "Aspect ratio",
    editor_hook: "Hook text",
    editor_trim: "Trim",
    editor_start: "Start",
    editor_end: "End",
    editor_export: "Export clip",
    editor_exported: "Clip exported! (demo)",
    editor_autocaptions: "Auto captions",
    editor_why_viral: "Why it can go viral",

    checkout_title: "Checkout",
    checkout_plan: "Plan",
    checkout_card: "Card number",
    checkout_name: "Name on card",
    checkout_expiry: "Expiry",
    checkout_cvc: "CVC",
    checkout_pay: "Pay",
    checkout_demo: "Demo only — no real charge is made.",
    checkout_success: "Payment successful! (demo)",
  },
  es: {
    nav_features: "Funciones",
    nav_sources: "Fuentes",
    nav_how: "Cómo funciona",
    nav_pricing: "Precios",
    nav_signin: "Iniciar sesión",
    nav_create: "Crear cuenta",
    nav_studio: "Abrir Studio",

    hero_title_1: "Convierte cualquier vídeo largo en",
    hero_title_2: "Shorts Virales",
    hero_sub: "Clips automáticos con IA, subtítulos y un Viral Score para TikTok, Reels y Shorts.",
    hero_placeholder: "Pega un enlace de YouTube",
    hero_cta: "Crear clips ahora",
    hero_note: "Planes desde 9,99$/mes · Cancela cuando quieras",
    hero_trust: "Con la confianza de +2.4M creadores · 4.9 de 5",

    sources_title: "Una IA de clipping, todas las fuentes de vídeo",
    sources_sub: "Pega un enlace de YouTube, Vimeo, Kick o Twitch — o sube tu propio archivo.",

    how_title: "Cómo funciona",
    how_sub: "De un vídeo largo a clips virales en 3 simples pasos",
    how_1_title: "Pega un enlace de YouTube",
    how_1_desc: "Pega cualquier vídeo. Podcast, gaming, formato largo — lo que sea.",
    how_2_title: "La IA crea los clips",
    how_2_desc: "Nuestra IA encuentra los momentos virales, añade subtítulos y los puntúa.",
    how_3_title: "Edita y publica",
    how_3_desc: "Ajusta en el editor y exporta para TikTok, Reels y Shorts.",

    pricing_title: "Precios simples que crecen contigo",
    pricing_sub: "Empieza gratis. Mejora cuando quieras. Cancela cuando quieras.",
    pricing_monthly: "Mensual",
    pricing_yearly: "Anual",
    pricing_save: "Ahorra 40%",
    pricing_month: "/mes",
    pricing_free_forever: "para siempre",

    plan_trial_name: "Prueba Gratis",
    plan_pro_name: "Pro",
    plan_premium_name: "Premium",
    plan_vip_name: "VIP",

    testimonials_title: "Creadores de todo el mundo lo adoran",
    testimonials_sub: "Únete a miles que convierten vídeos largos en shorts virales.",

    cta_title: "¿Listo para hacerte viral?",
    cta_sub: "Pega un vídeo y consigue tus primeros clips en minutos.",
    cta_button: "Empieza gratis",

    footer_tagline: "Convierte vídeos largos en clips virales con IA.",
    footer_product: "Producto",
    footer_company: "Empresa",
    footer_legal: "Legal",
    footer_rights: "Todos los derechos reservados.",

    studio_title: "Clip Studio",
    studio_chat_hint: "Pega un enlace de YouTube y encontraré los momentos más virales para ti.",
    studio_input_placeholder: "Pega un enlace de YouTube aquí...",
    studio_generate: "Generar clips",
    studio_invalid: "Eso no parece un enlace válido de YouTube. Prueba con otro.",
    studio_analyzing: "Analizando el vídeo...",
    studio_finding: "Buscando momentos virales...",
    studio_scoring: "Puntuando los clips...",
    studio_captions: "Escribiendo subtítulos...",
    studio_done: "Encontré {n} clips con alto potencial viral 🔥",
    studio_your_clips: "Tus clips",
    studio_viral_score: "Viral Score",
    studio_edit: "Editar clip",
    studio_export: "Exportar",
    studio_back: "Volver a los clips",
    studio_you: "Tú",
    studio_new: "Nuevo vídeo",

    editor_title: "Editor de clips",
    editor_preview: "Vista previa",
    editor_caption_style: "Estilo de subtítulo",
    editor_aspect: "Relación de aspecto",
    editor_hook: "Texto del gancho",
    editor_trim: "Recortar",
    editor_start: "Inicio",
    editor_end: "Fin",
    editor_export: "Exportar clip",
    editor_exported: "¡Clip exportado! (demo)",
    editor_autocaptions: "Subtítulos automáticos",
    editor_why_viral: "Por qué puede hacerse viral",

    checkout_title: "Pago",
    checkout_plan: "Plan",
    checkout_card: "Número de tarjeta",
    checkout_name: "Nombre en la tarjeta",
    checkout_expiry: "Caducidad",
    checkout_cvc: "CVC",
    checkout_pay: "Pagar",
    checkout_demo: "Solo demo — no se realiza ningún cobro real.",
    checkout_success: "¡Pago realizado! (demo)",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const v = localStorage.getItem("trimo_lang");
    return CODES.includes(v) ? v : "es";
  });
  const setLang = useCallback((v) => setLangState(CODES.includes(v) ? v : "es"), []);

  useEffect(() => {
    localStorage.setItem("trimo_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = "ltr";
  }, [lang]);

  // translate an English source string into the active (non es/en) language
  const tr = useCallback((en) => (auto[lang] && auto[lang][en]) || en, [lang]);
  const L = useCallback((es, en) => (lang === "es" ? es : lang === "en" ? en : tr(en)), [lang, tr]);
  const pick = useCallback((obj) => {
    if (!obj) return obj;
    if (obj[lang] !== undefined) return obj[lang];
    return Array.isArray(obj.en) ? obj.en.map(tr) : tr(obj.en);
  }, [lang, tr]);

  const t = useCallback(
    (key, vars) => {
      let str = (translations[lang] && translations[lang][key]) || (translations.en[key] !== undefined ? tr(translations.en[key]) : key);
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.replace(`{${k}}`, vars[k]);
        });
      }
      return str;
    },
    [lang, tr]
  );

  const toggleLang = () => setLang((l) => (l === "en" ? "es" : "en"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t, L, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
